import { render, staticRenderFns } from "./topshop.vue?vue&type=template&id=4f4ddb56&scoped=true&"
import script from "./topshop.vue?vue&type=script&lang=js&"
export * from "./topshop.vue?vue&type=script&lang=js&"
import style0 from "./topshop.vue?vue&type=style&index=0&id=4f4ddb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ddb56",
  null
  
)

export default component.exports